import Router from 'next/router';
import { _totalModels } from './json.js';
import SERVICES from '../services/service'
export const _textTruncate = (data, index) => {
     let showDots = false;
     data = data || '---';
     if (data.length >= index) showDots = true;
     return `${data.substring(0, index)}${showDots ? '...' : ''}`;
};

export const _checkLocation = (ctx, cookies) => {
     let location = cookies
     if (location == undefined) { } else {
          typeof window !== 'undefined'
               ? Router.push('/city', '/' + location)
               : ctx.res.writeHead(302, { Location: '/' + location }).end()
     }
};

export const _checkCookies = (ctx, cookies) => {
     let location = cookies
     if (location == undefined) {
          typeof window !== 'undefined'
               ? Router.push('/', '/')
               : ctx.res.writeHead(302, { Location: '/' }).end()
     } else { }
};

export const _setCookies = async(ctx, location, device, model) => {
     let mydeviceModels = []
     if(location && device && model){
          let deviceModels = await SERVICES._brandModels({"location": location, "brand": device})
          if(deviceModels.status){
               mydeviceModels = deviceModels.models
          }
     }
     var modelData = mydeviceModels;
     if (typeof window !== 'undefined') {
          location !== undefined && (document.cookie = `location=` + location);
          device !== undefined && (
               (device != '')
                    ? document.cookie = `device=` + device
                    : Router.push('/_error.js', 'error')
          );
          model !== undefined && (
               modelData.find(res => {
                    if (res.name == model.split("-").join(" ")) {
                         return true
                    }
               })
                    ? document.cookie = `model=` + model
                    : Router.push('/_error.js', 'error')
          );
     } else {
          location !== undefined && ctx.res.cookie('location', location);
          device !== undefined && (
               (device != '')
                    ? ctx.res.cookie('device', device)
                    : ctx.res.writeHead(302, { Location: '/_error' }).end()
          );
          model !== undefined && (
               modelData.find(res => {
                    if (res.name == model.split("-").join(" ")) {
                         return true
                    }
               })
                    ? ctx.res.cookie('model', model)
                    : ctx.res.writeHead(302, { Location: '/_error' }).end()
          );
     }
};

export const _getFilterArray = (array, obj) => {
     array.map(res => {
          if (res.name == obj.name) {
               if (res.isChecked) {
                    res.isChecked = false
               } else {
                    res.isChecked = true
               }
          } else {
               res.isChecked = false
          }
     })
     return array;
};

export const _proceedValue = (array) => {
     var result = ""
     array.map(res => {
          if (res.isChecked) {
               result = res.name
          }
     })
     return result;
};

export const _proceedHttpValue = (array) => {
     var result = ""
     array.map(res => {
          if (res.isChecked) {
               result = { "model_name": (res.name).split(' ').join('-'), "sName": res.name }
          }
     })
     return result;
};

export const _truncateRepairShop = (array) => {
     var result = ""
     var data = []
     data = array.split('-');
     data.map((res, index) => {
          if (res == 'Repair' || res == 'Shop') {
          } else {
               result = result + res
          }
     })
     return result;
};

export const _truncateRepair = (array) => {
     var result = ""
     var data = []
     data = array.split('-');
     data.map((res, index) => {
          if (res == 'Repair' || res == 'Shop') {

          } else {
               if ((data.length - 2) == index) {
                    result = result + res
               } else {
                    result = result + res + '-'
               }
          }
     })
     return result;
};

export const _nameReplacer = (array) => {
     var result = ""
     var data = []
     data = array.split('-');
     data.map((res, index) => {
          result = result + res + ""
     })
     return result;
};

export const _camaSeparate = (array) => {
     var result = ""
     var data = array
     if (data !== undefined) {
          if (data.length > 0) {
               data.map((res, index) => {
                    if (index == (data.length - 1)) {
                         var text = ''
                         var content = res.name.split('&')
                         content.map((item, I) => {
                              if ((content.length - 1) == I) {
                                   text = text + item
                              } else {
                                   text = text + item + ' and '
                              }
                         })
                         result = result + text
                    } else {
                         var text = ''
                         var content = res.name.split('&')
                         content.map((item, cindex) => {
                              if ((content.length - 1) == cindex) {
                                   text = text + item
                              } else {
                                   text = text + item + ' and '
                              }
                         })
                         result = result + text + ", "
                    }
               })
          }
     }
     return result;
};

export const _getTheDeice = (ctx) => {
     let isMobileView = (ctx.req
          ? ctx.req.headers['user-agent']
          : navigator.userAgent).match(
               /Android|BlackBerry|iPhone|iPad|iPod|Opera Mini|IEMobile|WPDesktop/i
          )
     return isMobileView
}

export const _getCities = async()=>{
     let result =await SERVICES._allCities();
        let priorityCities = new Array();
        let otherCities = new Array();
        if(result.status){
            priorityCities = result.priorityCities ? result.priorityCities : [];
            otherCities = result.otherCities ? result.otherCities : []
        }
        return {locations: priorityCities, otherCities:otherCities}
}

export const _getAllbrands = async()=>{
     let result =await SERVICES._allBrands();
        let brands = new Array();
        if(result.status)
            brands = result.brands;
        return {devices: brands}
}

export default {
     _textTruncate,
     _checkLocation,
     _getFilterArray,
     _proceedValue,
     _proceedHttpValue,
     _checkCookies,
     _setCookies,
     _truncateRepairShop,
     _truncateRepair,
     _nameReplacer,
     _camaSeparate,
     _getTheDeice,
     _getCities,
     _getAllbrands
};
